import { render, staticRenderFns } from "./filePreviewModal.vue?vue&type=template&id=bd3a28e6&"
import script from "./filePreviewModal.vue?vue&type=script&lang=js&"
export * from "./filePreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports